import { render, staticRenderFns } from "./SingleRecommended.vue?vue&type=template&id=0e78a2e4"
import script from "./SingleRecommended.vue?vue&type=script&lang=js"
export * from "./SingleRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports